import { render, staticRenderFns } from "./MyCardContent.vue?vue&type=template&id=5b202e4e&scoped=true"
import script from "./MyCardContent.vue?vue&type=script&lang=js"
export * from "./MyCardContent.vue?vue&type=script&lang=js"
import style0 from "./MyCardContent.vue?vue&type=style&index=0&id=5b202e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b202e4e",
  null
  
)

export default component.exports